import type { AppEnvironment } from './interface';

export const environment = <AppEnvironment>{};
